<template>
    <div v-on:click="edit" class="inline-image inline-input">
        <img :src="_.imgPath(initialValue, 'w80')" :style="css" />
        <!-- <i> (Click to edit)</i> -->
        <i class="material-icons inline-input-icon">edit</i>
    </div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';

export default {
    data() {
        return {
            value: this.initialValue,
            active: false,
        }
    },

    components: { },

    props: ['initialValue', 'css', 'schema'],

    watch: {
        selectedAsset(newAsset) {
            if (!this.active) return;
            if (_.get(newAsset, 'id') == _.get(this.initialValue, 'id')) return;
            this.$emit('change', newAsset);
            this.active = false;
        },
        fileModalOpen(newValue) {
            if (!newValue) this.active = false;
        }
    },

    computed: {
        ...Vuex.mapGetters('assets', {
            assets: 'content',
            selectingAsset: 'selectingAsset',
            selectedAsset: 'selectedAsset',
            fileModalOpen: 'fileModalOpen',
            fileModalConfig: 'fileModalConfig',
        }),
    },

    methods: {
        ...Vuex.mapActions('assets', [
            'selectAsset', 'commitAsset',
            'closeAssetModal', 'openAssetModal',
            'configAssetModal',
        ]),

        edit() {
            this.configAssetModal({
                multiple: false,
                extensions: _.get(this.schema, 'extensions', []),
            });
            this.selectAsset(_.get(this.initialValue, 'id'));
            this.commitAsset();
            this.openAssetModal();

            this.$nextTick(() => {
                this.active = true;
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/InlineGlobalModalImageComponent.vue